// Dealers.jsx

import React, { useState, useEffect } from "react";
import {
  User,
  Mail,
  Phone,
  MapPin,
  Pin,
  BadgeDollarSign,
  Eye,
  X,
  Calendar,
} from "lucide-react";

import axios from "axios";
import "../css/Dealers.css";

const Dealers = () => {

  const [dealers, setDealers] = useState([]);

  const [selectedDealer, setSelectedDealer] =
    useState(null);

  useEffect(() => {
    fetchDealers();
  }, []);

  const fetchDealers = async () => {

    try {

      const res = await axios.get(
        "/api/dealers"
      );

      setDealers(res.data.data || []);

    } catch (error) {

      console.error(
        "Error fetching dealers:",
        error
      );
    }
  };

  return (
    <div className="dealers-page">

      {/* HEADER */}
      <div className="dealers-header">

        <div>
          <h1>Dealer Enquiries</h1>

          <p>
            Manage all submitted dealer
            enquiry forms
          </p>
        </div>

        <div className="dealers-count-card">
          Total Enquiries: {dealers.length}
        </div>

      </div>

      {/* TABLE */}
      <div className="dealers-table-wrapper">

        <table className="dealers-table">

          <thead>

            <tr>
              <th>ID</th>
              <th>Customer</th>
              <th>Email</th>
              <th>Phone</th>
              <th>City</th>
              <th>Investment</th>
              <th>Date</th>
              <th>Action</th>
            </tr>

          </thead>

          <tbody>

            {dealers.map((dealer) => (

              <tr key={dealer.id}>

                <td>
                  <span className="dealers-id">
                    #{dealer.id}
                  </span>
                </td>

                <td>
                  <div className="dealers-name">
                    {dealer.name}
                  </div>
                </td>

                <td>{dealer.email}</td>

                <td>{dealer.phone}</td>

                <td>{dealer.city}</td>

                <td>
                  <div className="dealers-investment">
                    {dealer.investmentPlan}
                  </div>
                </td>

                <td>

                  {new Date(
                    dealer.submittedAt
                  ).toLocaleDateString()}

                </td>

                <td>

                  <button
                    className="dealers-view-btn"
                    onClick={() =>
                      setSelectedDealer(dealer)
                    }
                  >

                    <Eye size={16} />

                    View

                  </button>

                </td>

              </tr>
            ))}

          </tbody>

        </table>

      </div>

      {/* MODAL */}
      {selectedDealer && (

        <div className="dealers-modal-overlay">

          <div className="dealers-modal">

            {/* HEADER */}
            <div className="dealers-modal-header">

              <div>

                <h2>
                  Dealer #{selectedDealer.id}
                </h2>

                <p>

                  Submitted on{" "}

                  {new Date(
                    selectedDealer.submittedAt
                  ).toLocaleDateString()}

                </p>

              </div>

              <button
                className="dealers-close-btn"
                onClick={() =>
                  setSelectedDealer(null)
                }
              >

                <X size={26} />

              </button>

            </div>

            {/* BODY */}
            <div className="dealers-modal-body">

              {/* DETAILS */}
              <div className="dealers-section">

                <h3>Dealer Enquiry Details</h3>

                <div className="dealers-details-grid">

                  <div className="dealers-detail-card">

                    <User size={18} />

                    <div>
                      <span>Full Name</span>
                      <p>
                        {selectedDealer.name}
                      </p>
                    </div>

                  </div>

                  <div className="dealers-detail-card">

                    <Mail size={18} />

                    <div>
                      <span>Email</span>
                      <p>
                        {selectedDealer.email}
                      </p>
                    </div>

                  </div>

                  <div className="dealers-detail-card">

                    <Phone size={18} />

                    <div>
                      <span>Phone</span>
                      <p>
                        {selectedDealer.phone}
                      </p>
                    </div>

                  </div>

                  <div className="dealers-detail-card">

                    <MapPin size={18} />

                    <div>
                      <span>State</span>
                      <p>
                        {selectedDealer.state}
                      </p>
                    </div>

                  </div>

                  <div className="dealers-detail-card">

                    <MapPin size={18} />

                    <div>
                      <span>City</span>
                      <p>
                        {selectedDealer.city}
                      </p>
                    </div>

                  </div>

                  <div className="dealers-detail-card">

                    <Pin size={18} />

                    <div>
                      <span>Pincode</span>
                      <p>
                        {selectedDealer.pincode}
                      </p>
                    </div>

                  </div>

                  <div className="dealers-detail-card">

                    <Pin size={18} />

                    <div>
                      <span>
                        Additional Pincode
                      </span>

                      <p>
                        {selectedDealer.extraPincode ||
                          "-"}
                      </p>
                    </div>

                  </div>

                  <div className="dealers-detail-card">

                    <BadgeDollarSign size={18} />

                    <div>
                      <span>
                        Investment Plan
                      </span>

                      <p>
                        {
                          selectedDealer.investmentPlan
                        }
                      </p>
                    </div>

                  </div>

                  <div className="dealers-detail-card">

                    <Calendar size={18} />

                    <div>
                      <span>
                        Submitted At
                      </span>

                      <p>

                        {new Date(
                          selectedDealer.submittedAt
                        ).toLocaleString()}

                      </p>
                    </div>

                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dealers;